/*
 * @Description: get-mini-app-methods 导出mini-app方法
 * @Author: fiveonelei
 * @Date: 2022-02-10 10:59:15
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-get-common-method/get-schema-methods.ts
 */
import { useStore } from '@/store/index';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import useProvideBrowserInfo from '@/composable/use-provide-browser-info';
import useProvideCookieInfo from '@/composable/use-provide-cookie-info';
import { addLogSour, formatVideoCollectionSchema } from '@/utils/schema';
import { getLatestClickReportInfo } from '@/utils/common';
import { loadWslSchemaAsync, loadWeseeClipboardAsync } from '@/utils/load-wslib';
import getBrowserObj from '@/utils/no-import-meta/get-browser-obj';
import { getQueryObj } from '@/utils/no-import-meta/url';
import { IS_SSR } from '@/utils/env';

const DOWNLOAD_PAGE_NORMAL = 'https://isee.weishi.qq.com/iseev2/1/PSg56S8_e/index.html?_wwv=4096&chid=100002010&attach=cp_reserves3_1000020006';
const DOWNLOAD_PAGE_COLLECTION = 'https://isee.weishi.qq.com/iseev2/1/PSg56S8_e/index.html?_wwv=4096&chid=100081003&attach=cp_reserves3_1000370721';
const DOWNLOAD_PAGE_QZONE = 'https://isee.weishi.qq.com/iseev2/1/PSg56S8_e/index.html?_wwv=4096&chid=204003124&attach=cp_reserves3_2020010013';

export default function useSchemaMethods() {
  const { state } = useStore();
  const { info: urlInfo } = useProvideUrlInfo();
  const { info: browerInfo } = useProvideBrowserInfo();
  const { info: cookieInfo } = useProvideCookieInfo();
  let isInstall: null | boolean = null;

  enum EChannelFrom {
    shareVideoWeixin = 'share_video_weixin',
    shareVideoQQ = 'share_video_qq',
    shareVideoQQzone = 'share_video_qqzone',
    shareVideoOther = 'share_video_other',
  }

  const appendSchema = async function (schema: string, isAddLogSour = false) {
    const arr = [];
    const { spid = '', id: feedId, rtx = '' } = urlInfo.query || {};
    let client = '';
    let newSchema = schema;

    if (isAddLogSour) {
      newSchema = await addLogSour(schema);
    }
    switch (browerInfo.client) {
      case 'wx':
        client = EChannelFrom.shareVideoWeixin;
        break;
      case 'qq':
        client = EChannelFrom.shareVideoQQ;
        break;
      case 'qzone':
        client = EChannelFrom.shareVideoQQzone;
        break;
      default:
        client = EChannelFrom.shareVideoOther;
    }
    const index = state.activeIndex;

    const curPosterId = state.feedsList?.[index]?.posterId || '';
    // 上一次点击操作上报 position
    const position = getLatestClickReportInfo()?.position || null;

    const extDa = {
      test_id: state.growthTestData?.strategyID || '',
      openid: cookieInfo.openid || cookieInfo.silent_openid,
      channel_from: client,
      rtx,
      spid,
      feedid: feedId,
      owenerid: curPosterId,
      position,
    };
    // 分享渠道
    arr.push(`${client}=${encodeURIComponent(spid)}`);
    arr.push(`ext_da=${encodeURIComponent(JSON.stringify(extDa))}`);

    const suffix = ~schema.indexOf('?') ? '&' : '?';
    return newSchema + suffix + arr.join('&');
  };

  const openSchemaCheckInstallInQQAppendParams = async function (
    appendParams: boolean,
    isCollection: boolean,
    ...schema: any[]
  ) {
    if (IS_SSR) return;

    const wsSchema = await loadWslSchemaAsync();
    const weseeClipboard = await loadWeseeClipboardAsync();
    if (!wsSchema || !weseeClipboard) return;

    if (isInstall === null) {
      isInstall = !!window._isInstall_;
    }
    const { WSClipboard: wSClipboard } = weseeClipboard;
    // 自己手动写剪贴板，weishi-lib里写剪贴板逻辑有误
    // @ts-ignore
    let formatedSchema = wsSchema.formatSchema(...schema);
    if (appendParams) {
      formatedSchema = await appendSchema(formatedSchema);
    }
    if (!isInstall) {
      wSClipboard.write(formatedSchema);
    }
    const browserInfo = getBrowserObj();
    const { scene } = getQueryObj();
    // 手q不能直接下载，需要跳中间页
    if (browserInfo.client === 'qq' && window.mqq) {
      if (!isInstall) {
        let href;
        if (scene === '6') {
          href = DOWNLOAD_PAGE_QZONE;
        } else {
          href = isCollection ? DOWNLOAD_PAGE_COLLECTION : DOWNLOAD_PAGE_NORMAL;
        }
        window.mqq.invoke('ui', 'openUrl', {
          url: href,
          target: 1,
          style: 1,
        });
        return;
      }
    }

    wsSchema.openSchema(formatedSchema);
  };

  const openSchemaAppendParamsClipboard = async function (appendParams: boolean, ...schema: any[]) {
    if (IS_SSR) return;

    const wsSchema = await loadWslSchemaAsync();
    const weseeClipboard = await loadWeseeClipboardAsync();
    if (!wsSchema || !weseeClipboard) return;
    if (isInstall === null) {
      isInstall = !!window._isInstall_;
    }
    const { WSClipboard: wSClipboard } = weseeClipboard;
    // @ts-ignore
    let formatedSchema = wsSchema.formatSchema(...schema);
    if (appendParams) {
      formatedSchema = await appendSchema(formatedSchema);
    }
    if (!isInstall) {
      wSClipboard.write(formatedSchema);
    }
    wsSchema.openSchema(formatedSchema);
  };

  const openCollectionSchema = async function () {
    const { collectionid: collectionId = '', id: feedId = '' } = urlInfo.query || {};
    const { isCollection, activeIndex } = state;
    openSchemaCheckInstallInQQAppendParams(
      true,
      isCollection,
      formatVideoCollectionSchema(collectionId, feedId, activeIndex),
    );
  };
  return {
    appendSchema, openSchemaCheckInstallInQQAppendParams, openSchemaAppendParamsClipboard, openCollectionSchema,
  };
}
